import { mapActions, mapMutations, mapGetters, mapStates } from 'src/vuex/baseModule'

const collection = 'ranking'

const model = {
  winners: [],
  reserves: [],
  canceled: []
}

const getters = Object.assign({...mapGetters()}, {
  loading: state => state.loading
})

const mutations = Object.assign({}, {
  ...mapMutations(),
  setWinners: (state, payload) => {
    state.winners = payload
  },
  setReserves: (state, payload) => {
    state.reserve = payload
  },
  setCanceled: (state, payload) => {
    state.canceled = payload
  }
})

const actions = Object.assign({}, {
  ...mapActions(collection, model),

  setRanking ({commit}, {winners, reserves, canceled}) {
    if (winners) {
      commit('setWinners', winners)
    }
    if (reserves) {
      commit('setReserves', reserves)
    }
    if (canceled) {
      commit('setCanceled', canceled)
    }
  }
})

export default {
  namespaced: true,

  state: {
    ...mapStates(),
    loading: false,
    all: [],
    one: Object.assign({}, model),
    count: 0
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ranking.js